// extracted by mini-css-extract-plugin
export default {"closeIconButton":"newCloseIcon_closeIconButton__iC39e"};